import React from "react";
import { Lock, Globe } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/utils/utils";

interface FileAccessBadgeProps {
  isPublic?: boolean;
  showLabel?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const FileAccessBadge: React.FC<FileAccessBadgeProps> = ({
  isPublic = false,
  showLabel = true,
  size = "md",
  className,
}) => {
  const iconSize = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  }[size];

  const badgeSize = {
    sm: "text-xs px-1.5 py-0.5",
    md: "text-sm px-2 py-1",
    lg: "text-base px-3 py-1.5",
  }[size];

  if (isPublic) {
    return (
      <Badge
        className={cn(
          "bg-green-100 text-green-800 border-green-200 hover:bg-green-200",
          badgeSize,
          className,
        )}
        variant="outline"
      >
        <Globe className={cn(iconSize, showLabel && "mr-1")} />
        {showLabel && "Public"}
      </Badge>
    );
  }

  return (
    <Badge
      className={cn(
        "bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-200",
        badgeSize,
        className,
      )}
      variant="outline"
    >
      <Lock className={cn(iconSize, showLabel && "mr-1")} />
      {showLabel && "Private"}
    </Badge>
  );
};
